import styled from '@emotion/styled';

import { Link } from 'react-router-dom';

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import AssuredWorkloadRoundedIcon from '@mui/icons-material/AssuredWorkloadRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';

import { BasicFlex, Notes } from '../../../utils/Common';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

import { formatCurrency, formatPhoneNumber } from '../../../utils/util';

import NoTimeline from '../../../utils/utilities/Timeline/NoTimeline';

import TimelineWithComments from '../../../utils/utilities/Timeline/TimelineWithComments';

const Balance = styled.div`
  font-size: 2.4rem;
  font-weight: 600;
`

const ProfileTab = () => {
  const { data = {} } = usePageData();

  const detailsBlock = [
    {header: "Name", icon: <AccountBoxOutlinedIcon fontSize='small' />, info: data.full_name},
    {header: "Email", icon: <EmailOutlinedIcon fontSize='small' />, info: data.email},
    {header: "Mobile", icon: <PhoneOutlinedIcon fontSize='small' />, info: formatPhoneNumber(data.mobile_phone)},
  ];

  let addressStr = ""
  if (data.address) {
    addressStr = `${data.address}`
  }
  if (data.city) {
    addressStr += `, ${data.city}`
  }
  if (data.state) {
    addressStr += `, ${data.state}`
  }
  if (data.country) {
    addressStr += `, ${data.country}`
  }

  const addressBlock = [
    {header: "Address", icon: <LocationOnOutlinedIcon fontSize='small' />, align: "flex-start", info: addressStr},
  ];

  const activityBlock = [
    {header: "Active", info: data.is_active, dataType: "boolean", booleanValues: ["Active", "Inactive"]},
    {header: "Date Created", info: data.created_at, dataType: "date"},
  ];

  const balanceBlock = [
    {header: "Balance", icon: <AccountBalanceWalletOutlinedIcon fontSize='small' />, dataType: "currency", info: data.balance},
  ];

  return (
    <Grid container spacing={3}>
      <Grid size={{xs: 12, md: 4}}>
        <Card variant='outlined'>
          <CardHeader title="Basic Details" />
          <CardContent>
            <CardBlockContainer>
              <CardBlockHeader>Contact Information</CardBlockHeader>
              {detailsBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}
              <CardSpacer />

              <CardBlockHeader>Address</CardBlockHeader>
              {addressBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />
              <CardBlockHeader>Activity</CardBlockHeader>
              {activityBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />
              <CardBlockHeader>Notes</CardBlockHeader>
              <Notes>{data.notes}</Notes>
        
            </CardBlockContainer>
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{xs: 12, md: 8}}>
        <BasicFlex dir="column" gap="2.4rem">
           <Card variant='outlined'>
          <CardHeader title="Customer Balance"
            action={
              <Link to={`/payments/edit`} state={{customer_id: data.customer_id?.toString(), client_name: data.full_name, mobile_phone: data.mobile_phone, email: data.email}} >
                <Button variant='contained' size='small' startIcon={<PaymentsRoundedIcon />}>Pay Now</Button>
              </Link>
            }
            sx={{gap: "6rem"}}
          />
          <CardContent sx={{pt: 0}}>
            <Balance>{formatCurrency(data.balance)}</Balance>
          </CardContent>
        </Card>
          <Card variant='outlined' sx={{width: "100%"}}>
            <CardHeader title={<BasicFlex gap="1rem">Customer History <HistoryRoundedIcon /></BasicFlex>} />
            <CardContent>
              <TimelineWithComments resource="customers" resource_id={data.customer_id} />
            </CardContent>
          </Card>
        </BasicFlex>
       
      </Grid>

    </Grid>
  );

};

export default ProfileTab;